"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tag", {
    enumerable: true,
    get: function() {
        return Tag;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _Text = require("../Text/Text");
const _ri = require("react-icons/ri");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Tag = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { className = "", size = "small", variant = "default", type = "default", value, limit, children, onClose, ...props } = param;
    const { colors } = (0, _Theme.useTheme)();
    const sizeVariant = size === "large" ? "default" : "small";
    const borderRadius = type === "default" ? "2px" : size === "large" ? "16px" : "8px";
    const closeButtonSize = size === "large" ? 18 : 15;
    const closeButtonClass = size === "large" ? "close-tag-large" : "close-tag";
    const closeButtonColor = (0, _react.useMemo)(()=>{
        let color;
        switch(variant){
            case "default":
                color = colors.grayscale[60];
                break;
            case "positive":
                color = colors.status.positive.primary;
                break;
            case "negative":
                color = colors.status.danger.primary;
                break;
            case "warning":
                color = colors.status.warning.primary;
                break;
            case "bright":
                color = colors.dark;
                break;
            case "dark":
                color = colors.white;
                break;
            case "primary":
                color = colors.blue[60];
                break;
            default:
                color = colors.grayscale[60];
                break;
        }
        return color;
    }, [
        colors,
        variant
    ]);
    const closeHoverColor = (0, _react.useMemo)(()=>{
        let color;
        switch(variant){
            case "default":
                color = colors.grayscale[20];
                break;
            case "positive":
                color = colors.transparent.positive[10];
                break;
            case "negative":
                color = colors.transparent.danger[10];
                break;
            case "warning":
                color = colors.transparent.warning[10];
                break;
            case "bright":
                color = colors.transparent.black[10];
                break;
            case "dark":
                color = colors.transparent.white[10];
                break;
            case "primary":
                color = colors.blue[20];
                break;
            default:
                color = colors.grayscale[20];
                break;
        }
        return color;
    }, [
        colors,
        variant
    ]);
    const formattedValue = (0, _react.useMemo)(()=>{
        if (typeof value === "number" && value != null && limit != null && value > 0 && limit > 0) {
            if (value.toString().length > limit) {
                return "".concat(Array(limit + 1).join("9"), "+");
            }
        }
        return (value !== null && value !== void 0 ? value : 0).toString();
    }, [
        value,
        limit
    ]);
    return /*#__PURE__*/ _react.default.createElement("span", {
        ref: ref,
        ...props,
        className: _style.default.dynamic([
            [
                "da643728769513a5",
                [
                    borderRadius,
                    colors.transparent.black[5],
                    colors.grayscale[60],
                    colors.transparent.black[60],
                    colors.white,
                    colors.transparent.white[80],
                    colors.dark,
                    colors.blue[60],
                    colors.white,
                    colors.status.positive.accent,
                    colors.status.positive.primary,
                    colors.status.danger.accent,
                    colors.status.danger.primary,
                    colors.status.warning.accent,
                    colors.status.warning.primary,
                    colors.blue.transparent[10],
                    colors.blue[60],
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    closeHoverColor,
                    closeHoverColor
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "tag tag-".concat(variant, " tag-").concat(size, " ").concat(className))
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "label",
        size: sizeVariant,
        className: "tag-label"
    }, type === "counter" ? formattedValue : children, onClose != null && /*#__PURE__*/ _react.default.createElement("span", {
        onClick: (e)=>{
            e.stopPropagation();
            onClose();
        },
        className: _style.default.dynamic([
            [
                "da643728769513a5",
                [
                    borderRadius,
                    colors.transparent.black[5],
                    colors.grayscale[60],
                    colors.transparent.black[60],
                    colors.white,
                    colors.transparent.white[80],
                    colors.dark,
                    colors.blue[60],
                    colors.white,
                    colors.status.positive.accent,
                    colors.status.positive.primary,
                    colors.status.danger.accent,
                    colors.status.danger.primary,
                    colors.status.warning.accent,
                    colors.status.warning.primary,
                    colors.blue.transparent[10],
                    colors.blue[60],
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    borderRadius,
                    closeHoverColor,
                    closeHoverColor
                ]
            ]
        ]) + " " + (closeButtonClass || "")
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseFill, {
        size: closeButtonSize,
        color: closeButtonColor
    }))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "da643728769513a5",
        dynamic: [
            borderRadius,
            colors.transparent.black[5],
            colors.grayscale[60],
            colors.transparent.black[60],
            colors.white,
            colors.transparent.white[80],
            colors.dark,
            colors.blue[60],
            colors.white,
            colors.status.positive.accent,
            colors.status.positive.primary,
            colors.status.danger.accent,
            colors.status.danger.primary,
            colors.status.warning.accent,
            colors.status.warning.primary,
            colors.blue.transparent[10],
            colors.blue[60],
            borderRadius,
            borderRadius,
            borderRadius,
            borderRadius,
            closeHoverColor,
            closeHoverColor
        ]
    }, ".tag.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap;vertical-align:middle;-webkit-border-radius:".concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, "}.tag.__jsx-style-dynamic-selector .tag-label{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap;vertical-align:middle}.tag-large.__jsx-style-dynamic-selector{padding:.25rem .5rem}.tag-small.__jsx-style-dynamic-selector{padding:0 .25rem}.tag-default.__jsx-style-dynamic-selector{background:").concat(colors.transparent.black[5], ";color:").concat(colors.grayscale[60], "}.tag-dark.__jsx-style-dynamic-selector{background:").concat(colors.transparent.black[60], ";color:").concat(colors.white, "}.tag-bright.__jsx-style-dynamic-selector{background:").concat(colors.transparent.white[80], ";color:").concat(colors.dark, "}.tag-primary-counter.__jsx-style-dynamic-selector{background:").concat(colors.blue[60], ";color:").concat(colors.white, "}.tag-positive.__jsx-style-dynamic-selector{background:").concat(colors.status.positive.accent, ";color:").concat(colors.status.positive.primary, "}.tag-negative.__jsx-style-dynamic-selector{background:").concat(colors.status.danger.accent, ";color:").concat(colors.status.danger.primary, "}.tag-warning.__jsx-style-dynamic-selector{background:").concat(colors.status.warning.accent, ";color:").concat(colors.status.warning.primary, "}.tag-primary.__jsx-style-dynamic-selector{background:").concat(colors.blue.transparent[10], ";color:").concat(colors.blue[60], "}.close-tag.__jsx-style-dynamic-selector{margin-left:3px;padding:0px 2px 0 2px;margin-right:-4px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;-moz-border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;cursor:pointer}.close-tag-large.__jsx-style-dynamic-selector{padding:3px;margin:-4px -8px -4px 4px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;-moz-border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;border-radius:0 ").concat(borderRadius, " ").concat(borderRadius, " 0;cursor:pointer}.close-tag-large.__jsx-style-dynamic-selector:hover{background-color:").concat(closeHoverColor, "}.close-tag.__jsx-style-dynamic-selector:hover{background-color:").concat(closeHoverColor, "}")));
});
Tag.displayName = "Tag";

//# sourceMappingURL=Tags.js.map